import { defineMessages } from 'react-intl';

const messages = defineMessages({
  createTransactionBatch: {
    id: 'App.CreateTransactionBatch.CreateTransactionBatch',
    defaultMessage: 'Create New Transaction Batch',
  },
});

export default messages;
